module.exports = __webpack_public_path__ + "img/auth-illus.53c53dbe.jpg";